





















































import BaseLoading from '@/components/base/BaseLoading.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import BaseTable from '@/components/BaseTable.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import { CourseLicenseTemplateResponse } from '@/jbi-shared/dto/jtms.dtos';
import { CourseAttributeSortColumns } from '@/jbi-shared/types/jtms.types';
import { ApiState, SortOrder } from '@/store/types/general.types';
import { mixins } from 'vue-class-component';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { GroupLevelAttribute } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { courseAttributeSortableHeaders } from '@/store/modules/jtms/course-attribute/course-attribute.const';
import CourseAttributeRow from './CourseAttributeRow.vue';
import { RootState } from '@/store/store';
import { Action, State } from 'vuex-class';

@Component({
  components: {
    BaseTable,
    BasePagination,
    BaseLoading,
    SortableTableHeader,
    CourseAttributeRow
  }
})
export default class CourseAttributeList extends mixins(PaginationMixin) {
  @Prop() items!: GroupLevelAttribute[];
  @Prop(Number) currentPage!: number;
  @Prop(Number) totalNumberOfPage!: number;
  @Prop(Number) totalCount!: number;
  @Prop(Boolean) isFirstPage!: boolean;
  @Prop(Boolean) isLastPage!: boolean;
  @Prop(Number) startItemIndex!: number;
  @Prop(Number) endItemIndex!: number;
  @Prop(String) sortColumn!: CourseAttributeSortColumns;
  @Prop(String) sortOrder!: SortOrder;

  caRowKey: number = Math.floor(Math.random() * 999);

  @Action('course/getDefaultCourseLevelAttributes')
  getDefaultCourseLevelAttributes!: () => void;

  @State(
    ({ course }: RootState) => course.apiState.getDefaultCourseLevelAttributes
  )
  getDefaultCourseLevelAttributesApiState!: ApiState;

  @State(({ course }: RootState) => course.defaultCourseLevelAttributes)
  defaultCourseGLAs!: GroupLevelAttribute[];

  get courseAttributes() {
    return this.items || [];
  }

  get sortableHeaders() {
    return courseAttributeSortableHeaders;
  }

  get sortColumnEnum() {
    return CourseAttributeSortColumns;
  }

  get isPaginated() {
    return typeof this.totalNumberOfPage === 'number';
  }

  created() {
    if (!this.defaultCourseGLAs) {
      this.getDefaultCourseLevelAttributes();
    }
  }

  isDefaultCourseGLA(attribute: GroupLevelAttribute): boolean {
    if (this.defaultCourseGLAs) {
      return this.defaultCourseGLAs
        .map((gla) => Number(gla.id))
        .includes(Number(attribute.id));
    }

    return false;
  }

  onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder:
          this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: SortOrder.DESC
    });
    this.caRowKey += 1;
  }

  getSortOrderOfColumn(name: string) {
    if (this.sortColumn === name) {
      return this.sortOrder;
    }
    return SortOrder.ASC;
  }

  @Emit('edit-attribute')
  emitEditEvent(templateToEdit: CourseLicenseTemplateResponse) {
    return templateToEdit;
  }

  @Emit('delete-attribute')
  emitDeleteEvent(templateToDelete: CourseLicenseTemplateResponse) {
    return templateToDelete;
  }
}
